<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div>
                <div class="svg d-f">
                    <div :class="'svg' + list" v-for="list in 6">
                        <svg-model :is="'svg' + list"></svg-model>
                    </div>
                </div>
                <!-- <div class="svg d-f">
                    <div :class="'svg' + (list + 6)" v-for="list in 6">
                        <svg-model :is="'svg' + (list + 6)"></svg-model>
                    </div>
                </div> -->
                <div id="text2">一盏离愁 孤单伫立在窗口</div>
                <button @click="lrcRun">run</button>
                <div :class="[$style['my-scroll-bar'], 'LRC-load']">
                    <div class="line"></div>
                    <ul class="lrc-model">
                        <li v-for="(list, index) in lrc" :key="index">{{ list.v }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    import axios from 'axios'
    import Svg1 from './svg1.vue'
    import Svg2 from './svg2.vue'
    import Svg3 from './svg3.vue'
    import Svg4 from './svg4.vue'
    import Svg5 from './svg5.vue'
    import Svg6 from './svg6.vue'
    import Svg7 from './svg7.vue'
    /*import Svg8 from './svg8.vue'
    import Svg9 from './svg9.vue'
    import Svg10 from './svg10.vue'
    import Svg11 from './svg11.vue'
    import Svg12 from './svg12.vue'*/
    export default{
        name:'svg',
        components:{
            'svg1': Svg1,
            'svg2': Svg2,
            'svg3': Svg3,
            'svg4': Svg4,
            'svg5': Svg5,
            'svg6': Svg6,
            /*'svg7': Svg7,
            'svg8': Svg8,
            'svg9': Svg9,
            'svg10': Svg10,
            'svg11': Svg11,
            'svg12': Svg12,*/
        },
        data(){
            return {
                lrc:{}
            }
        },
        methods:{
            iconvReadLRC(){
                axios.get('/static/2.lrc').then(res => {
                    var arr = res.data.split('\r\n');
                    var obj = {}
                    var f_obj = []
                    arr.forEach(function(list, i) {
                        var a = list.split(']');
                        if(a[0].split('[')[1]){
                            var t = a[0].split('[')[1];
                            var t_s = +(t.split(":")[0]) * 60 + parseInt(t.split(":")[1]);
                            if(t_s || t_s === 0){
                                obj[t_s] = a[1];
                                f_obj.push({
                                    t:t_s,
                                    v:a[1]
                                })
                            }
                        }
                    })
                    this.lrc = f_obj;
                })
            },
            lrcRun(){
                this.lrc.forEach((list, i) => {
                    let n = i + 1
                    this.Move(i, list.t, n)
                })
            },
            Move(k, t, n){
                let self = this;
                let y = 80;
                var lrc_model = document.querySelector('.lrc-model');
                if(this.lrc[n]){
                    setTimeout(() => {
                        lrc_model.style.transform = 'translateY(' + (y - n * 20) + 'px)';
                    }, this.lrc[n].t * 1000)
                }else{
                    setTimeout(() => {
                        lrc_model.style.transform = 'translateY(' + y + 'px)';
                        // this.lrcRun();
                    }, this.lrc[k].t * 1000)
                }
            }
        },
        mounted(){
            this.iconvReadLRC()
        }
    }
</script>
<style module>
    .my-scroll-bar{
        height:200px;
        overflow: hidden;
    }
</style>
<style>
    @-webkit-keyframes loop{
        0%{background-position: -800px 0;}
        100%{background-position: -0 0;}
    }
    #text2{
        width: 800px;
        height: 78px;
        line-height: 78px;
        font-size: 40px;
        font-family: '微软雅黑';
        font-weight: bold;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-color: red;
        background-image:url('../../../assets/1.jpg');
        background-repeat:no-repeat;
        background-position: -800px 0;
        -webkit-animation:loop 10s linear infinite;
    }
    .LRC-load{
        border: 1px solid #ddd;
        padding: 10px;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        /*overflow: auto;*/
        position: relative;
    }
    .LRC-load ul{
        transition: transform 0.5s;
        transform: translateY(80px);
    }
    .lrc-model li {
        height: 20px;
    }
</style>
<style scoped>
    .line{
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 20px;
        z-index: 1000;
        transform: translateY(-50%);
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/svg/svg.vue